import React, { useEffect } from 'react';
import '../../../App.css';
import './Sculc2023.css';


import AOS from 'aos';
import 'aos/dist/aos.css';

const Sculc2023Presentation = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="sculc2023-page">
            <div className="sculc2023-header-container">
                <img
                    src="/images/balloons-clouds-word-clouds-abstract-dialogue-discussion-talk-graphic-background.jpg"
                    alt="Header"
                    className="sculc2023-header-image"
                />  
                <h1 className="sculc2023-title">Presentations</h1>
            </div>
            <div className="sculc2023-navbar">
                <div className="sculc2023-navbar-container">
                    <a href="/sculc-2023" className="sculc2023-links">Home</a>
                    <a href="/sculc-2023-program" className="sculc2023-links">Programs</a>
                    <a href="/sculc-2023-schedule" className="sculc2023-links">Schedule</a>
                    <a href="/sculc-2023-presentation" className="sculc2023-links">Presentation</a>
                    <a href="/sculc-2023-photo" className="sculc2023-links">Photos</a>
                </div>
            </div>
            <div className="sculc2023-container">
                <div className="sculc2023-table-container">
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                        <img src="/images/sculc2022/SCULC-logo-square.png"
                            alt="Sculc-logo"
                            className="sculc2023-logos"
                            style={{width: "100%"} }></img>
                        <p><i>Presenters are arranged in order of presentations according to the program. To view our program, click the program tab in the right corner.</i></p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/11RBRHIUa-5zw7B1S2QB20VDuQS1RhEn4/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }} ></iframe>
                        <p className="sculc2023-presenter-name">Andrew Kato</p>
                        <p>University of California, Santa Cruz</p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1YCDL5j8f95mfT6wpXozWpipIHR5kTkoE/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Anna Tong</p>
                        <p>University of California, Los Angeles</p>
                    </div>
                </div>
                <div className="sculc2023-table-container">
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1WMh2dPlxfr8QouNJN3ulzE1ErsXNFpzx/preview" frameborder="0" width="100%" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Ava Austin</p>
                        <p>San Francisco State University</p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1hmLFN5hutraNVax8rFk_5S7TMbOY5oCg/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Cedric Chan</p>
                        <p>University of Pennsylvania</p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1qaxR0mGREnHyQbvf81qB-h7_KhaR0wB5/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Daria Bahtina</p>
                        <p>University of California, Los Angeles</p>
                    </div>
                </div>
                <div className="sculc2023-table-container">
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1ah68OoD970AnrfVAk5HI4ze7P7dJzqwT/preview" frameborder="0" width="100%" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Jacob Atticus Bushard</p>
                        <p>University of California, Riverside</p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1rCqVYW1V5NTTjfJObEe6vEBDAEyEmO6X/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p style={{ textAlign: "center", fontSize: "1.8em", color: "#4499cc", lineHeight: "1.6em" }}>Jayce Garner, Alexis Burke, Fanny Brogan</p>
                        <p>Pomona College & Scripps College</p>
                    </div>
                    <div className="sculc2023-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/18yGkwa6j-m49v0uJXqpxciUu_NEnnMGb/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2023-presenter-name">Madeleine Kostant</p>
                        <p>University of California, Los Angeles</p>
                    </div>
                </div>
                
            </div>
            <div style={{ height: "5vh" }}></div> {/* bottom spacing */}
            
                
        </div>
    );
};

export default Sculc2023Presentation;
